import LinkedAccountForm from "./LinkedAccountForm";
import {hasPermission} from "../../../helpers/utils/AccessControlUtils";
import { useState } from "react";


const UpdateLinkedAccount = () => {

  
    const [crumbs] = useState([
        { content: "Home", url: "/" },
        { content: "Linked Accounts", url: "/linked-accounts" },
        { content: "Update Linked Account", url: "" },
    ]);

    return (
        <>
            <LinkedAccountForm crumbs={crumbs} title={"Update Linked Account"} btnText={"Update"}
                               isReadOnly={!hasPermission(["LINKACC-U"])}/>
        </>
    )
}
export default UpdateLinkedAccount;